import {Row, Col, Card, Button, Skeleton, Rate, Image, Tag, Table} from "antd";
import React, {useState, useEffect} from "react";
import {useParams, Link} from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import {ShowToast, Severty} from "../../helper/toast";
import Main from "../../components/layout/Main";
import apiPath from "../../constants/apiPath";
import moment from 'moment';
import {PRICE} from "../../constants/conts";
import {Badge} from 'antd';
import notfound from "../../assets/images/not_found.png"
import {AssignWasher} from "./AssignWasher";


function View() {
    const params = useParams();
    const [id, setId] = useState();


    const {request} = useRequest();
    const [list, setList] = useState({});
    const [history, setHisory] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [carColor, setCarColor] = useState('');
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [items, setItems] = useState(false)
    const [carwashes, setCarwashes] = useState(false)
    const [completionTime, setCompletionTime] = useState(false)
    const [selected, setSelected] = useState();

    const assignWasher = (id) => {

        if(id){
            setVisible(true)
        }
    };

    const ratingStatus = ['Terrible', 'Bad', 'Normal', 'Good', 'Wonderful'];
    const serviceColumns = [
        {
            title: "Car",
            dataIndex: "car_id",
            key: "car_id",
            render: (_, {car}) => {
                return (
                    <>{car?.car_number ?? '-'}</>
                );
            },

        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",


        },
        {
            title: "additional_services",
            dataIndex: "additional_services",
            key: "additional_services",
            render: (_, {additional_services}) => {
                return (
                    <>{additional_services?.map((item, index) => <span
                        key={item._id}>{item.name}<br/></span>) ?? '-'}</>
                );
            },

        },
        {
            title: "Feature list",
            dataIndex: "service_id",
            key: "service_id",
            render: (_, {service}) => {
                return (
                    <>{service?.feature_list.map((item, index) => <span key={index}>{item}<br/></span>) ?? '-'}</>
                );
            },

        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",

        }
    ];
    const carwasheColumns = [
        {
            title: "Car",
            dataIndex: "car",
            key: "car",
            render: (_, {car}) => {
                return (
                    <>{car?.car_number ?? '-'}</>
                );
            },

        },
        {
            title: "Address",
            dataIndex: "latitude",
            key: "latitude",
            render: (_, {latitude, longitude}) => {
                return (
                    latitude && longitude ? (
                        <a
                            href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View on Map
                        </a>
                    ) : (
                        "-"
                    )
                );
            },

        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",


        },     {
            title: "Time",
            dataIndex: "time",
            key: "time",
        }, {
            title: "User Subscription",
            dataIndex: "user_subscription_id",
            key: "user_subscription_id",
            render: (_, {usersubscription}) => {
                return (
                    usersubscription?.subscription_name ?? '-'
                );
            },
        }, {
            title: "Before",
            dataIndex: "before",
            key: "before",
            render: (_, record) => {
                return   record.before ? (<img src={record?.before_url} alt="" width="100px"  />) :' - '
            },
        }, {
            title: "After",
            dataIndex: "after",
            key: "after",
            render: (_, record) => {
              return   record.after ? (<img src={record?.after_url} alt="" width="100px"  />) :' - '
            },
        }, {
            title: "User Subscription",
            dataIndex: "user_subscription_id",
            key: "user_subscription_id",
            render: (_, {usersubscription}) => {
                return (
                    usersubscription?.subscription_name ?? '-'
                );
            },
        }, {
            title: "Service",
            dataIndex: "service",
            key: "service",
            render: (_, {service}) => {
                return (
                    service?.name ?? '-'
                );
            },
        },
        {
            title: "Washer",
            dataIndex: "washer",
            key: "washer",
            render: (_,record) => {
                return (

                    <a onClick={(e) => {setSelected(record); assignWasher(record._id); }}><Tag color={record?.washer?.name ? "success" : "red"} key={record?.washer?.name ? "success" : "danger"}>
                        {record?.washer?.name ?record?.washer?.name : "Un-Assigned"}
                    </Tag></a>


                );
            },
        },

        {
            title: "Services",
            dataIndex: "services",
            key: "services",
            render: (_, {services}) => {
                return (
                    services?.map((item, index) => <span key={index}>{item.name}<br/></span>) ?? '-'
                );
            },
        },

    ];

    useEffect(() => {
        fetchData(params.id);
    }, [refresh])
    const fetchData = (id) => {
        setLoading(true);
        request({
            url: apiPath.viewNewOrder + "/" + id,
            method: 'GET',
            onSuccess: (data) => {
                setLoading(false);
                setList(data.data.order);
                setHisory(data.data.getOrderStatus);
                setItems(data.data.items);
                setCarwashes(data.data.carwashes);
                setCompletionTime(data.data.completion_time);
                setCarColor(data.data.getOrder?.car_id?.color_id?.color);
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR)
            }
        })
    }
    return (
        <Main>
            <Row gutter={16}>
                <Col span={12}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Card title="Order Details" bordered={false}>
                                {loading ? [1, 2, 3, 4].map(item => <Skeleton active key={item}/>) :
                                    <div className="view-main-list">

                                        <div className="view-inner-cls">
                                            <h5>Order ID:</h5>
                                            <h6>{list.random_order_id}</h6>
                                        </div>


                                        <div className="view-inner-cls">
                                            <h5>Customer Name:</h5>
                                            <h6 className="cap">{list && list.user_id && list.user_id.name ?
                                                <Link className="cap"
                                                      to={`/customer/view/${list.user_id._id}`}>{list.user_id.name}</Link> : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Customer Email:</h5>
                                            <h6>{list && list.user_id && list.user_id.email ? list.user_id.email : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Customer Contact No.:</h5>
                                            <h6>{list.user_id ? (list.user_id.country_code ? "+" + list.user_id.country_code + "-" : "+968") + (list.user_id.mobile_number ? list.user_id.mobile_number : '') : '-'}</h6>
                                        </div>


                                        <div className="view-inner-cls">
                                            <h5>Rating Received:</h5>
                                            <h6>{list.is_rate ? "Yes" : "No"}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Status:</h5>
                                            <h6>{
                                                list.status === 'new' ?
                                                    <Badge colorSuccess status="cyan" text="New"/> :
                                                    list.status === 'complete' ?
                                                        <Badge colorSuccess status="success" text="Completed"/> :
                                                        list.status === 'cancel' ?
                                                            <Badge status="error" text="Cancelled"/> :
                                                            list.status === 'in-progress' ?
                                                                <Badge status="cyan" text="In-Progress"/>
                                                                : <Badge status="yellow" text="Un-Assigned Order"/>
                                            }

                                            </h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Service Date & Time:</h5>
                                            <h6>{list.date_time_stamp ? moment(list.date_time_stamp).format('DD-MMM-YYYY, hh:mm A') : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Created On:</h5>
                                            <h6>{list.created_at ? moment(list.created_at).format('DD-MM-YYYY, hh:mm A') : '-'}</h6>
                                        </div>

                                    </div>
                                }
                            </Card>
                        </Col>

                        <Col span={24}>
                            <Card title="Rating & Review" className="h-100 mt-4">
                                <Row gutter={16}>
                                    <Col span={12} xs={24} md={24}>

                                        {loading ? [1, 2].map(item => <Skeleton active key={item}/>) :
                                            <div className="view-main-list">

                                                <div className="view-inner-cls">
                                                    <h5>Rating:</h5>
                                                    <h6><Rate tooltips={ratingStatus} value={list.rate}/></h6>
                                                </div>

                                                <div className="view-inner-cls">
                                                    <h5>Review:</h5>
                                                    <h6>{list && list.review ? list.review : '-'}</h6>
                                                </div>

                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col span={24}>
                            <Card title="Payment Details" bordered={false}>
                                {loading ? [1, 2, 3, 4].map(item => <Skeleton active key={item}/>) :
                                    <div className="view-main-list">

                                        <div className="view-inner-cls">
                                            <h5>Discount
                                                Amount{list.discount_id && list.discount_id.code ? ' (' + list.discount_id.code + ')' : null}:</h5>
                                            <h6>{list.discount_amount ? list.discount_amount + ' (' + PRICE + ')' : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>{'Sub Total'}:</h5>
                                            <h6>{list.sub_total + ' (' + PRICE + ')'}</h6>
                                        </div>
                                        <div className="view-inner-cls">
                                            <h5>{'Completion time'}:</h5>
                                            <h6>{completionTime.price + ' (' + PRICE + ')'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Tariff Charges:</h5>
                                            <h6>{list.tariff_charge ? list.tariff_charge + ' (' + PRICE + ')' : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Grand Total:</h5>
                                            <h6>{list.total ? list.total + ' (' + PRICE + ')' : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Status:</h5>
                                            <h6 className="cap">{list.payment_status ? list.payment_status : 'Pending'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Payment Mode:</h5>
                                            <h6 className="cap">{list.payment_method ? list.payment_method : '-'}</h6>
                                        </div>

                                        {list.payment_status == 'paid' ?
                                            <>
                                                <div className="view-inner-cls">
                                                    <h5>Received On:</h5>
                                                    <h6>{list.payment_received_on ? moment(list.created_at).format('DD-MM-YYYY') : '-'}</h6>
                                                </div>

                                                <div className="view-inner-cls">
                                                    <h5>Payment Session ID:</h5>
                                                    <h6>{list.payment_session_id ? list.payment_session_id : '-'}</h6>
                                                </div>
                                            </>
                                            : null}

                                        {/* <div className="view-inner-cls">
                  <h5>OTP Verified:</h5>
                  <h6>{ list.is_otp_verify ? <Tag color="green" > Verified </Tag> : <Tag color="red"> Not Verified </Tag> }</h6>
                </div>

                <div className="view-inner-cls">
                  <h5>OTP Verified On:</h5>
                  <h6>{list.created_at ? moment(list.created_at).format('DD-MMM-YYYY, hh:mm A') : '-'}</h6>
                </div> */}

                                    </div>
                                }
                            </Card>
                        </Col>
                        <Col span={24} className="mt-4">
                            <Card title="Address" className="h-100">
                                {loading ? [1, 2].map(item => <Skeleton active key={item}/>) :
                                    <div className="view-main-list">

                                        <div className="view-inner-cls">
                                            <h5>Location:</h5>
                                            <h6>
                                                {list && list.city ? list.city : ''}
                                                {list && list.state ? " - " + list.state : ''}
                                                {list && list.country ? " - " + list.country : ''}
                                            </h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Landmark:</h5>
                                            <h6 className="cap">{list && list.landmark ? list.landmark : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>House No:</h5>
                                            <h6 className="cap">{list && list.house_no ? list.house_no : '-'}</h6>
                                        </div>

                                        <div className="view-inner-cls">
                                            <h5>Address:</h5>
                                            <h6 className="cap">{list && list.address ? list.address : '-'}</h6>
                                        </div>
                                        <div className="view-inner-cls">
                                            <h5>Google map:</h5>
                                            <h6 className="cap">
                                                {list && list.latitude && list.longitude ? (
                                                    <a
                                                        href={`https://www.google.com/maps?q=${list.latitude},${list.longitude}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        View on Map
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </h6>
                                        </div>

                                    </div>
                                }
                            </Card>
                        </Col>
                    </Row>

                </Col>
            </Row>

            <Row className="mt-4">
                <Col span={24}>
                    <div className="view-main-list p-3">
                        <Table
                            loading={loading}
                            columns={serviceColumns}
                            dataSource={items}
                            className="ant-border-space"
                        />
                    </div>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col span={24}>
                    <div className="view-main-list p-3">
                        <Table
                            loading={loading}
                            columns={carwasheColumns}
                            dataSource={carwashes}
                            className="ant-border-space"
                        />
                    </div>
                </Col>
            </Row>
            {visible && <AssignWasher show={visible} hide={() => { setVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}

        </Main>
    )

}

export default View;